import { render, staticRenderFns } from "./promoteProductBlock.vue?vue&type=template&id=6dd60d47&"
import script from "./promoteProductBlock.vue?vue&type=script&lang=js&"
export * from "./promoteProductBlock.vue?vue&type=script&lang=js&"
import style0 from "./promoteProductBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports